import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_SOLLECITO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlSollecitoState extends EntityState<IID_OL_SOLLECITO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_SOLLECITO })
@InterfaceDataStore(InterfaceName.ORDINE_OLO)
export class IIDolSollecitoStore extends EntityStore<IIdOlSollecitoState> {
  constructor() {
    super([]);
  }
}
